import { Button } from '@material-ui/core';
import React from 'react'
import { withRouter } from "react-router-dom";
import { DialogComponent } from '../../../components/dialog/DialogComponent';
import TableComponent, { TableOp } from '../../../components/table/TableOps';
import Cliente from './Cliente';
import ClientesReporte from './ClientesReporte';
import ClientesSubir from './ClientesSubir';
import ACCESS from '../../../ACCESS';

class Clientes extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'cliente/filter', deleteUrl: 'cliente/delete', deleteField: 'cliente_rsocial', modUrl: '/Catalogo/Cliente' },
      TableOp.Table('Clientes', [
        { label: 'Cliente', id: 'cliente' },
        { label: 'Razón social', id: 'cliente_rsocial' },
        { label: 'RFC', id: 'cliente_rfc' },
        { label: 'F/M', id: 'genero' },
        { label: 'DV', id: 'cliente_dv' },
        { label: 'Descripción', id: 'cliente_desc' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_CLIENTES.EDITAR_CATALOGO] },
      ])
    );
    this.table();
  }

  action = (id, row) => {
    if (id === 'edit') {
      this.props.history.push(`/Catalogo/Cliente/${row.id}/Generales`)
    }
    else if (id === 'delete') {
      this.delete(row)
    }
  }

  onReporteClick = () => {
    this.setState({ reporteDialog: true });
  }

  render() {
    const {
      reporteDialog = false,
    } = this.state;

    return (
      <div>
        <div>
          <Cliente  onSave={() => { this.table() }}></Cliente>

          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <ClientesSubir />
            <Button variant='outlined' onClick={this.onReporteClick}>Reporte</Button>
          </div>

          <this.TableRender  />
        </div>

        <DialogComponent open={reporteDialog} title='Reportes de clientes' onClose={() => this.setState({ reporteDialog: false })}>
          <ClientesReporte />
        </DialogComponent>
      </div>
    )
  }
}

export default withRouter(Clientes)